module.exports = __webpack_public_path__ + "img/investment_2.e2c582b3.jpg";